import styled from 'styled-components';

export const StyledWidgetFrame = styled.div`
  width: 100vw;
  max-width: 100%;
  height: ${({ $height }) => $height};
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: ${({ theme }) => theme.background};

  .scroller {
    position: relative;
    height: 100%;
    width: 100%;
    border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  }

  .screen-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
  }

  .screen-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .screen-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .screen-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .screen-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: 12px 12px;
  }
`;
